import i18n from '@/i18n';
import { invert } from 'lodash';

const MessangerTypes = {
  TELEGRAM: 1,
  FACEBOOK: 2,
  WHATSAPP: 3,
  VIBER: 4
};

export const OrderPaymentStatus = {
  PENDING: 0,
  CONFIRMED: 1,
  REJECTED: 2,
  CANCELLED: 3,
  REFUNDED: 4,
  USER_READY_TO_PAY: 5
};

const OrderProgressStatus = {
  IN_PROCESSING: 0,
  IN_QUEUE: 1,
  IN_PROGRESS: 2,
  IN_DELIVERY: 3,
  DELIVERED: 4
};

export const ServiceTypes = {
  UNIQUE_REQUIREMENTS_REQUEST: 0,
  SUPPORT_SERVICE_REQUEST: 1,
  DEVELOPMENT_REQUEST: 2,
  INDIVIDUAL_CONSULTATIONS: 3,
  DEVELOPER_CALL: 4,
  ANTI_DDOS_24_7: 5,
  SEO_OPTIMIZATION: 6,
  CONVERSION_INCREASE_SERVICE: 7,
  BUSINESS_AD_IN_MESSENGERS: 8,
  WITHDRAWAL_REQUEST: 9,
  COMMISSION_OR_PENALTY: 10,
  AMNESTY_PENALTY_OR_FINES_REQUEST: 11
};

export const providers = [
  {
    id: MessangerTypes.TELEGRAM,
    type: 'telegram',
    label: i18n.global.t('telegramProvider'),
    logo: require('@/assets/images/providers/telegram-ico.png')
  },
  {
    id: MessangerTypes.WHATSAPP,
    type: 'whatsapp',
    label: i18n.global.t('whatsappProvider'),
    logo: require('@/assets/images/providers/whatsapp-ico.png')
  }
];

const contactType = {
  TELEGRAM: 1,
  WHATSAPP: 2,
  WHATSAPP_BUSINESS: 3
};
export const contactTypes = [
  {
    id: contactType.WHATSAPP,
    type: 'whatsapp',
    label: i18n.global.t('whatsappProvider'),
    logo: require('@/assets/images/providers/whatsapp-ico.png')
  },
  {
    id: contactType.WHATSAPP_BUSINESS,
    type: 'whatsapp_business',
    label: i18n.global.t('whatsappBusinessProvider'),
    logo: require('@/assets/images/providers/whatsapp-ico.png')
  }
];

export const orderStatuses = [
  {
    id: OrderProgressStatus.IN_PROCESSING.toString(),
    type: 'processing',
    label: i18n.global.t('orderStatusInProcessing'),
    color: '#c7c7c7'
  },
  {
    id: OrderProgressStatus.IN_QUEUE.toString(),
    type: 'pending',
    label: i18n.global.t('orderStatusPending'),
    color: '#fa9441'
  },
  {
    id: OrderProgressStatus.IN_PROGRESS.toString(),
    type: 'progress',
    label: i18n.global.t('orderStatusProcessing'),
    color: '#02c4fc'
  },
  {
    id: OrderProgressStatus.IN_DELIVERY.toString(),
    type: 'picked-up',
    label: i18n.global.t('orderStatusPickedUp'),
    color: '#78d25b'
  },
  {
    id: OrderProgressStatus.DELIVERED.toString(),
    type: 'delivered',
    label: i18n.global.t('orderStatusDelivered'),
    color: '#000000'
  }
];

export const msgTypes = {
  image: 'm.image',
  video: 'm.video',
  sticker: 'm.sticker',
  text: 'm.text',
  file: 'm.file',
  replace: 'm.replace',
  location: 'm.location',
  notice: 'm.notice',
  gif: 'm.gif',
  read: 'm.read',
  audio: 'm.audio'
};

export const eventTypes = {
  message: 'm.room.message',
  member: 'm.room.member',
  avatar: 'm.room.avatar',
  redaction: 'm.room.redaction',
  create: 'm.room.create',
  topic: 'm.room.topic',
  name: 'm.room.name'
};

export const chatNamesForBridge = {
  telegram: 'tg_bridge_bot',
  whatsapp: 'wa_bridge_bot'
};

export const messengerProviders = {
  telegram: 'telegram',
  whatsapp: 'whatsapp'
};

export const selfMembershipTypes = {
  invite: 'invite',
  join: 'join',
  leave: 'leave'
};

export const roles = {
  ADMIN: 0,
  SUPPORT: 1
};

export const discountTypes = {
  percentage: 'percentage',
  fixed: 'fixed'
};

export const InputTypes = {
  TEXT: 1,
  NUMBER: 2,
  DATE: 3,
  TIME: 4,
  EMAIL: 5,
  PHONE: 6,
  URL: 7,
  FILE: 8,
  LOCATION: 9,
  SELECT: 10,
  MULTI_SELECT: 11,
  RADIO: 12,
  CHECKBOX: 13,
  IMAGE: 14,
  VIDEO: 15,
  AUDIO: 16,
  DOCUMENT: 17,
  PASSWORD: 18,
  TEXTAREA: 19,
  HTML: 20,
  MARKDOWN: 21,
  COLOR: 22,
  RANGE: 23,
  SLIDER: 24,
  STAR_RATING: 25,
  EMOJI: 26
};

export const connectionStatuses = {
  NEW: 1,
  WORKING: 2,
  SCAN_QR_CODE: 3,
  STOPPED: 4,
  STARTING: 5,
  FAILED: 6
};

export const statisticViewTypes = {
  month: 'month',
  quarter: 'quarter'
}
export const monthOptions = [
  {
    number: 0,
    name: 'All'
  },
  {
    number: 1,
    name: 'January'
  },
  {
    number: 2,
    name: 'February'
  },
  {
    number: 3,
    name: 'March'
  },
  {
    number: 4,
    name: 'April'
  },
  {
    number: 5,
    name: 'May'
  },
  {
    number: 6,
    name: 'June'
  },
  {
    number: 7,
    name: 'July'
  },
  {
    number: 8,
    name: 'August'
  },
  {
    number: 9,
    name: 'September'
  },
  {
    number: 10,
    name: 'October'
  },
  {
    number: 11,
    name: 'November'
  },
  {
    number: 12,
    name: 'December'
  }
]

export const dayList = [
  {
    id: 1,
    name: i18n.global.t('monday'),
    short: 'monday',
    to: 'mondayTo',
    from: 'mondayFrom',
    breakFrom: 'mondayBreakFrom',
    breakTo: 'mondayBreakTo',
    aroundClockServer: 'monday_24h',
    aroundClock: 'monday24H'
  },
  {
    id: 2,
    name: i18n.global.t('tuesday'),
    short: 'tuesday',
    to: 'tuesdayTo',
    from: 'tuesdayFrom',
    breakFrom: 'tuesdayBreakFrom',
    breakTo: 'tuesdayBreakTo',
    aroundClockServer: 'tuesday_24h',
    aroundClock: 'tuesday24H'
  },
  {
    id: 3,
    name: i18n.global.t('wednesday'),
    short: 'wednesday',
    to: 'wednesdayTo',
    from: 'wednesdayFrom',
    breakFrom: 'wednesdayBreakFrom',
    breakTo: 'wednesdayBreakTo',
    aroundClockServer: 'wednesday_24h',
    aroundClock: 'wednesday24H'
  },
  {
    id: 4,
    name: i18n.global.t('thursday'),
    short: 'thursday',
    to: 'thursdayTo',
    from: 'thursdayFrom',
    breakFrom: 'thursdayBreakFrom',
    breakTo: 'thursdayBreakTo',
    aroundClockServer: 'thursday_24h',
    aroundClock: 'thursday24H'
  },
  {
    id: 5,
    name: i18n.global.t('friday'),
    short: 'friday',
    to: 'fridayTo',
    from: 'fridayFrom',
    breakFrom: 'fridayBreakFrom',
    breakTo: 'fridayBreakTo',
    aroundClockServer: 'friday_24h',
    aroundClock: 'friday24H'
  },
  {
    id: 6,
    name: i18n.global.t('saturday'),
    short: 'saturday',
    to: 'saturdayTo',
    from: 'saturdayFrom',
    breakFrom: 'saturdayBreakFrom',
    breakTo: 'saturdayBreakTo',
    aroundClockServer: 'saturday_24h',
    aroundClock: 'saturday24H'
  },
  {
    id: 7,
    name: i18n.global.t('sunday'),
    short: 'sunday',
    to: 'sundayTo',
    from: 'sundayFrom',
    breakFrom: 'sundayBreakFrom',
    breakTo: 'sundayBreakTo',
    aroundClockServer: 'sunday_24h',
    aroundClock: 'sunday24H'
  }
];


// remove later

export const StatusTypes = {
  order: 1,
  preDelivery: 4,
  delivery: 5,
  dispute: 7
};
export const statusConfigs = {
  [StatusTypes.order]: {
    id: StatusTypes.order,
    type: 'orderStatus',
    className: 'status-order-color',
    availableStatuses: [1, 2, 3, 4, 5, 6, 8, 9],
    titleKey: 'orderStatuses'
  },
  [StatusTypes.preDelivery]: {
    id: StatusTypes.preDelivery,
    type: 'preDeliveryStatus',
    className: 'status-pre-delivery-color',
    availableStatuses: [1, 2, 8],
    titleKey: 'preDeliveryStatuses'
  },
  [StatusTypes.dispute]: {
    id: StatusTypes.dispute,
    type: 'disputeStatus',
    className: 'status-dispute-color',
    availableStatuses: 'all',
    titleKey: 'disputeStatus'
  },
  [StatusTypes.delivery]: {
    id: StatusTypes.delivery,
    type: 'deliveryStatus',
    className: 'status-delivery-color',
    availableStatuses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    titleKey: 'deliveryStatus'
  }
};

// eslint-disable-next-line no-unused-vars
export const statusTypes = {
  OrderAppealStatus: 13,
  OrderModerationStatus: 11,
  CustomerNotificationResponse: 10,
  DeliveryShipmentStatus: 9,
  DriverNotificationStatus: 8,
  DisputeStatus: 7,
  PostDeliveryStatus: 6,
  DeliveryStatus: 5,
  PreDeliveryStatus: 4,
  DeliveryModeStatus: 3,
  OrderPaymentStatus: 2,
  OrderStatus: 1
};
export const invertedStatusTypes = invert(statusTypes);

export const PaymentTypes = {
  CASH: 0,
  CASH_DEBIT: 1,
  ONLINE: 2,
  XPR: 3,
  CONTACT_ME: 4,
  INSURANCE: 5,
  REWARD: 6
};

export const PaymentTypesNames = {
  0: i18n.global.t('cash'),
  1: i18n.global.t('cashDebit'),
  2: i18n.global.t('card'),
  3: 'XPR',
  4: i18n.global.t('contactMe'),
  5: i18n.global.t('insurance'),
  6: i18n.global.t('reward')
};
